<div class="border border-gray-300 p-3 flex flex-col justify-start items-start basis-full" fxLayout="column"
  fxLayoutAlign="start start" fxFlex="0 0 100">
  <div fxLayout="row" fxFlex="0 0 auto">
    <h2>Deliveries/Collections</h2>
  </div>
  <ng-container *ngIf="deliveries().length; else noDeliveries">
    <div class="flex flex-row overflow-x-auto w-full">
      <table class="table" id="deliveries">
        <thead>
          <tr>
            <th>Type</th>
            <th>Location</th>
            <th>Items</th>
            <th>Due</th>
            <th>Status</th>
            <th>Charge</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let delivery of deliveries()">
            <tr>
              <td>{{ delivery.type | titlecase }}</td>
              <td>
                <div class="flex flex-row items-center justify-start">
                  <p>
                    {{ delivery.location | newLine }}
                  </p>
                  <button mat-icon-button (click)="
                      openInGoogleMaps(
                        delivery.location,
                        delivery.google_place_id
                      )
                    " matTooltip="Search in Google Maps">
                    <mat-icon class="text-blue-500">location_on</mat-icon>
                  </button>
                </div>
              </td>
              <td>
                {{ delivery.deliverableItemIds | deliverableItemList: potentialDeliveryItems() }}
              </td>
              <td>{{ delivery.due | amDateFormat: dateTimeFormat }}</td>
              <td>
                <delivery-status [delivery]="delivery" [matTooltip]="
                    delivery.fulfilled_date ? (delivery.fulfilled_date | amDateFormat:dateTimeFormat) : ''
                  ">
                </delivery-status>
              </td>
              <td>
                {{
                delivery.charge | hlCurrency: deliverableCurrency():currencyRate():false | async
                }}
              </td>
              <td>
                <span class="show-on-hover flex flex-row justify-start items-center">
                  <a (click)="showEditDialog(delivery)" *ngIf="canEdit()">Edit</a>
                  <button mat-icon-button [matMenuTriggerFor]="deliveryMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #deliveryMenu="matMenu">
                    <button mat-menu-item (click)="showCancelDialog(delivery)"
                      [disabled]="delivery.fulfilled_date || !canEdit()">
                      Cancel
                    </button>

                    <button mat-menu-item (click)="showCompleteDialog(delivery)" [disabled]="delivery.fulfilled_date">
                      Complete
                    </button>
                    <button mat-menu-item (click)="print(delivery)">
                      Print Fulfillment Note
                    </button>
                    <button mat-menu-item (click)="download(delivery)">
                      Download Fulfillment Note
                    </button>
                  </mat-menu>
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div fxLayout="row" fxFlex="0 0 auto">
      <button mat-raised-button (click)="addDelivery()" id="add-delivery-collection" [disabled]="!canAdd">
        <mat-icon>add</mat-icon>
        Add Job
      </button>
    </div>
  </ng-container>

  <ng-template #noDeliveries>
    <div fxLayout="column" id="no-deliveries-container">
      <p class="italic text-gray-700 tracking-wide mt-2 mb-2">
        No deliveries or collections added yet.
      </p>

      <div fxLayout="row" fxFlex="0 0 auto">
        <button mat-raised-button (click)="addDelivery()" [disabled]="!canAdd">
          <mat-icon>add</mat-icon>
          Add Job
        </button>
      </div>
    </div>
  </ng-template>
</div>
<iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>